import React, { useState } from "react";
import styled from "styled-components";
import { H5, P } from "../Texts";

import { Badge, PrimaryButton } from "../Buttons";
import AcceptReferralModal from "../../organisms/AcceptReferralModal";
import RejectReferralModal from "../../organisms/RejectReferralModal";

const ReferralsCardStyle = styled.div`
  border-radius: 3px;
  // width: ${(props) => props.width || "fit-content"};
  width: ${(props) => props.width || "333.67px"};
  // height: ${(props) => props.height || "360px"};
`;

export const ReferralsCard = ({ referral, width, height }) => {
  const [showCaseModal, setShowCaseModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [badgeColor, setBadgeColor] = useState({});
  const [badgeStatusColor, setBadgeStatusColor] = useState({});

  const toggleModal = () => setShowCaseModal(!showCaseModal);
  const toggleRejectModal = () => setShowRejectModal(!showRejectModal);

  const { user, from, serviceName, eligibilityStatus, status, service } = referral;

  React.useEffect(() => {
    switch (true) {
      case from === "form":
        setBadgeColor({
          bgColor: "#FDD2DC",
          textColor: "#7C033C",
        });
        break;

      case from === "sdep":
        setBadgeColor({
          bgColor: "#D8FDEC",
          textColor: "#167C3C",
        });
        break;

      default:
        setBadgeColor({
          bgColor: "#DCD6FE",
          textColor: "#2220A9",
        });
        break;
    }

    return () => {
      setBadgeColor({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    switch (true) {
      case status === "rejected":
        setBadgeStatusColor({
          bgColor: "#FDD2DC",
          textColor: "#7C033C",
        });
        break;

      case status === "approved":
        setBadgeStatusColor({
          bgColor: "#D8FDEC",
          textColor: "#167C3C",
        });
        break;

      default:
        setBadgeStatusColor({
          bgColor: "#DCD6FE",
          textColor: "#2220A9",
        });
        break;
    }

    return () => {
      setBadgeStatusColor({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ReferralsCardStyle
      width={width}
      height={height}
      className="bg-white p-4  hover:shadow-sm duration-300"
    >
      <div className="flex items-center justify-between">
        <Badge
          fontFamily="medium"
          bg={badgeColor.bgColor}
          color={badgeColor.textColor}
          className="uppercase referral-source"
          fontSize="12px"
        >
          {from}
        </Badge>

        <P
          color={eligibilityStatus ? "#167C3C" : "#D73636"}
          fontSize="13px"
          fontFamily="regular"
          smallSize="12px"
          className="my-0 mb-1 isEligible"
        >
          {eligibilityStatus ? "Eligible" : "Not Eligible"}
        </P>
      </div>

      <div className=" items-center">
        <div className="mt-5 flex items-center gap-x-2">
          <div
            className=" w-16 h-16 flex  items-center justify-center rounded-lg mb-3"
            style={{ background: "#EAE7FE" }}
          >
            <H5 color="#12046D" className="capitalize profile-dropdown-child">
              {`${user?.firstName?.[0]} ${user?.lastName?.[0]}`}
            </H5>
          </div>

          <div className="referral-user">
            <H5 color="#413E53" fontSize="16px" fontFamily="semi" smallSize="16px">
              {`${referral?.user?.firstName} ${referral?.user?.lastName}`}
            </H5>
            <P
              color="#716E8B"
              fontFamily="regular"
              fontSize="13px"
              smallSize="13px"
              className="my-0 text-center"
            >
              {user?.email}
            </P>
          </div>
        </div>

        <div
          style={{ background: "#F8F7FF" }}
          className="mt-4   px-4 py-3 rounded border border-[#E4E3EECC]"
        >
          <div className="referral-service">
            <P
              color="#000000"
              fontSize="12px"
              fontFamily="medium"
              smallSize="12px"
              className="my-0 mb-1"
            >
              Service
            </P>

            <P
              color="#252733"
              fontSize="13px"
              fontFamily="regular"
              smallSize="12px"
              className="my-0"
            >
              {serviceName}
            </P>
          </div>

          <div className="my-3 referral-case">
            <P
              color="#000000"
              fontSize="12px"
              fontFamily="medium"
              smallSize="12px"
              className="my-0 mb-1 font-medium"
            >
              Case Type
            </P>

            <P
              color="#252733"
              fontSize="13px"
              fontFamily="regular"
              smallSize="12px"
              className="my-0"
            >
              {service?.opCategory}
            </P>
          </div>

          <div className="case-summary">
            <P
              color="#000000"
              fontSize="12px"
              fontFamily="medium"
              smallSize="12px"
              className="my-0 mb-1 font-medium"
            >
              Case Summary
            </P>

            <P
              color="#252733"
              fontSize="13px"
              fontFamily="regular"
              smallSize="12px"
              className="my-0"
            >
              This case involves providing {service?.subOpCategory}
            </P>
          </div>
        </div>

        <div>
          <div>
            {status !== "pending" ? (
              <div className="case-status flex justify-center items-center mt-4">
                <Badge
                  className="uppercase"
                  fontFamily="semi"
                  bg={badgeStatusColor.bgColor}
                  color={badgeStatusColor.textColor}
                >
                  {status}
                </Badge>
              </div>
            ) : (
              <div className="mt-5 flex justify-center gap-x-2">
                <PrimaryButton
                  p="12px 20px"
                  className=" w-1/2 rounded accept-btn"
                  style={{ backgroundColor: "#442ED0", borderRadius: "3px" }}
                  onClick={toggleModal}
                >
                  Accept
                </PrimaryButton>
                <PrimaryButton.Light
                  p="12px 20px"
                  className="w-1/2 reject-btn"
                  style={{ backgroundColor: "#DCD6FE", borderRadius: "3px" }}
                  onClick={toggleRejectModal}
                >
                  Reject
                </PrimaryButton.Light>
              </div>
            )}
          </div>
        </div>
      </div>

      {showCaseModal && (
        <AcceptReferralModal closeModal={toggleModal} referral={referral} />
      )}
      {showRejectModal && (
        <RejectReferralModal closeModal={toggleRejectModal} referral={referral} />
      )}
    </ReferralsCardStyle>
  );
};
